module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/8-282fba9115e50d627e41756c428dc0b3.png";